import type { UseFormRegisterReturn } from 'react-hook-form';
import { SELL_DAYS_HINT, SELL_DAYS_LABEL } from '../vacationRequestForm.definitions';

export interface SellDaysCheckboxProps {
    registerProps: UseFormRegisterReturn<'sellDaysRequested'>;
}

export function SellDaysCheckbox({ registerProps }: SellDaysCheckboxProps) {
    return (
        <label className="flex cursor-pointer gap-3 rounded-xl border-2 border-dashed border-primary-300 bg-primary-50 p-4">
            <input
                type="checkbox"
                {...registerProps}
                className="mt-0.5 h-4 w-4 rounded text-primary-600 focus:ring-primary-500"
            />
            <span>
                <span className="block text-sm font-medium text-raro-gray-900 font-montserrat">
                    {SELL_DAYS_LABEL}
                </span>
                <span className="block text-xs text-raro-gray-600 font-montserrat">
                    {SELL_DAYS_HINT}
                </span>
            </span>
        </label>
    );
}

export default SellDaysCheckbox;
